import { blue, red } from '@material-ui/core/colors';
import { fuseDark } from '@fuse/fuse-colors';

const themesConfig = {
	default: {
		palette: {
			type: 'light',
			primary: fuseDark,
			secondary: {
				light: blue[600],
				main: blue[700],
				dark: blue[800]
			},
			error: red
		},
		status: {
			danger: 'orange'
		}
	},
	defaultDark: {
		palette: {
			type: 'dark',
			primary: fuseDark,
			secondary: {
				light: blue[600],
				main: blue[700],
				dark: blue[800]
			},
			error: red,
			background: {
				paper: '#1E1E1E',
				default: '#1D222F'
			}
		},
		status: {
			danger: 'orange'
		}
	}
};

export default themesConfig;
